export default {"src":"/_next/static/image/public/images/ic_remove.86aa535f1dfdd6dbb429856a03ca9394.svg","height":32,"width":32};